export default "__VITE_ASSET__DuzCcPvR__"